export default {
  name: 'channelOutput',
  data() {
    return {
      pageSize:8,
      pageIndex:1,
      total:0,
      addwebsitepop:false,
      rulepop:false,
      agreerule:false,
      loading:false,
      formValidate:{
        rssUrl:'',
        inputType:'rssDigest',
        robopostxmt:'Y'
      },
      ruleValidate: {
        rssUrl: [
          { required: true, message: '网址不能为空', trigger: 'change' },
          { type: 'url', message: '网址格式错误', trigger: 'change' }
        ],
        inputType: [
          { required: true, message: '类型不能为空', trigger: 'change' }
        ],
        robopostxmt: [
          { required: true, message: '发布设置不能为空', trigger: 'change' }
        ]
      },
      list:[]
    }
  },
  watch:{
    addwebsitepop(bool){
      if(!bool){
        this.$refs['addWebsiteValidate'].resetFields();
        this.agreerule=false;
      }
    }
  },
  computed:{
    pageCount(){
      return Math.ceil(this.total/this.pageSize);
    }
  },
  created() {
    //  console.log(this.$store.state.menuActiveName);
    this.getList();
  },
  mounted() {
  },
  methods: {
    showRule(){
      this.rulepop=true;
    },
    ruleNext(){
      this.rulepop=false;
      this.addwebsitepop=true;
    },
    ruleCancel(){
      this.rulepop=false;
    },
    changePage(page){
      this.pageIndex=page;
      this.getList();
    },
    getList(){
      this.loading=true;
      this.$http.get('front/channel',{params:{
       pagesize:this.pageSize,
       pageindex:this.pageIndex-1,
       type:'Rss',
       ptype:'input',
       audit:false
      }}).then((res)=>{
       this.loading=false;
      //  console.log(res);
       if(res.data.status == 1){
         this.total=res.data.total;
         this.list=res.data.channels;
       }else{
         this.total=0;
         this.$Notice.error({title:res.data.message,desc:false});
       }
      },(error)=>{
       this.loading=false;
       this.total=0;
       this.$Notice.success({title:error.data.message,desc:false});
      })
    },
    changeWebPublishType(type,id){
      if(type == "Y"){
        // 设置为自动
        this.confirmPop('确认将发布设置改为自动发布，修改后内容同步后将自动发布？',()=>{this.operateWebsitePublishType(type,id)},()=>{this.cancelSetPublishType('N',id)});
      }else{
        //设置为手动
        this.confirmPop('确认将发布设置改为手动发布，修改后内容状态为草稿，编辑后发布？',()=>{this.operateWebsitePublishType(type,id)},()=>{this.cancelSetPublishType('Y',id)});
      }
    },
    operateWebsitePublishType(type,id){
      ///api/channel/{_id
      this.$http.put('front/channel/'+id,{robopostxmt:type}).then(res => {
        if (res.data.status == 1) {
          this.$Notice.success({title:res.data.message,desc:false});
          //获得列表
          this.getList();
        } else {
          this.$Notice.error({title:res.data.message,desc:false});
        }
      }, err => {
        this.$Notice.error({title:err.data.message,desc:false});
      })
    },
    cancelSetPublishType(option,id){
       this.list.forEach((obj,key)=>{
        if(obj.id == id){
          obj.robopostxmt=option;
        }
      });
    },
    addWebsite(name){
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$http.post('front/rss',this.formValidate).then(res => {
           if (res.data.status == 1) {
            this.addwebsitepop = false;
             this.$Notice.success({title:res.data.message,desc:false});
             this.addblogpop=false;
             //获得列表
             this.getList();
           } else {
             this.addblogpop=false;
             this.$Notice.error({title:res.data.message,desc:false});
           }
          }, err => {
           this.$Notice.error({title:err.data.message,desc:false});
          })
        }
      })
    },
    confirmPop(content,sucCallback,failCallback){
      this.$Modal.confirm({
        title: '确认提示',
        content: content,
        onOk: () => {
          sucCallback && sucCallback();
        },
        onCancel: ()=>{
          failCallback && failCallback();
        }
      });
    },
    unbind(id){
      this.$http.delete('front/channel/'+id).then((response)=>{
       if(response.data.status == 1){
         this.$Notice.success({title:response.data.message,desc:false});
         this.getList();
       }else{
         this.$Notice.error({title:response.data.message,desc:false});
       }
      },(error)=>{
       this.$Notice.error({title:error.data.message,desc:false});
      })
    },
    unbindWebsite(id){
      this.confirmPop('你确定要解绑该网址渠道吗？',()=>{this.unbind(id)});
    }
  }
}



// WEBPACK FOOTER //
// ./src/view/channel/websiteadd/index.js